import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  panel: {
    background: theme.palette.background.modalBg,
    color: theme.palette.text.primary,
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",
    borderRadius: 16,
    padding: "24px 24px",
    border: "1px solid",
    borderColor: "black",
    transition: "background 0.3s, color 0.3s",
    height: "min-content",
    minWidth: "320px",
    width: "min-content",
    boxSizing: "border-box",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  panelBody: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },

  optionSelect: {
    background: theme.palette.background.modalBg,
    color: theme.palette.text.primary,
    fontFamily: "Philosopher",
    fontWeight: 900,

    textTransform: "none",
    borderRadius: 8,
    padding: "8px 16px",
    border: "1px solid",
    borderColor: "black",
    transition: "background 0.3s, color 0.3s",
    height: "min-content",
    width: "100%",

    "&:hover": {
      background: theme.palette.background.modalBg,
      opacity: 0.8,
      transition: "300ms",
    },

    [theme.breakpoints.down("lg")]: {
      width: "100%",
      boxSizing: "border-box",
      gap: 4,
      padding: "6px 16px",
      fontSize: 12,
    },

    "& div>div": {
      padding: 0,
      fontWeight: 900,
      justifyContent: "flex-start",
    },
  },

  input: {
    background: theme.palette.background.modalBg,
    color: theme.palette.text.primary,

    borderRadius: 8,
    padding: "8px 16px",
    border: "1px solid",
    borderColor: "black",
    transition: "background 0.3s, color 0.3s",
    height: "min-content",
    display: "flex",
    gap: 8,

    "&>div": {
      width: "100%",
    },

    "& input": {
      outline: "none",
      padding: 0,
      border: "none",
      fontFamily: "Philosopher",
      fontWeight: 900,
      textTransform: "none",
      width: "100%",
    },

    "& fieldset": {
      outline: "none",
      border: "none",
      minHeight: "40px",
    },

    "&:hover": {
      background: theme.palette.background.modalBg,
      opacity: 0.8,
      transition: "300ms",
    },

    [theme.breakpoints.down("lg")]: {
      width: "100%",
      boxSizing: "border-box",
      gap: 4,
      padding: "8px 16px",
      fontSize: 12,
    },
  },

  spinButton: {
    background: "#377934",
    color: theme.palette.text.primary,
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",
    borderRadius: 8,
    padding: "8px 32px",
    width: "100%",
    transition: "background 0.3s, color 0.3s",
    height: "min-content",

    "&:hover": {
      background: "#377934",
      opacity: 0.8,
      transition: "300ms",
    },

    "&:disabled": {
      background: theme.palette.background.lightGray,
    },
  },

  spinCount: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    width: "100%",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
    },
  },
}));

export default styles;
